import { AppShell, Burger, Group, NavLink, Stack, Text, UnstyledButton } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { modals } from '@mantine/modals';
import { IconKey, IconLogout } from '@tabler/icons-react';
import { ReactNode } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ROLE_NAMES } from '../api';
import { navFor } from '../nav';
import { useSession } from '../session';
import { ChangePasswordForm } from './ChangePasswordForm';

export function Layout({ children }: { children: ReactNode }) {
  const [opened, { toggle, close }] = useDisclosure();
  const { me, logout } = useSession();
  const { pathname } = useLocation();
  const roleText = (me?.roles ?? [])
    .map((r) => [ROLE_NAMES[r.role], r.department, r.legal_entity].filter(Boolean).join(' · '))
    .join('; ');
  const changePassword = () => {
    close();
    const id = modals.open({
      title: 'Смена пароля',
      children: <ChangePasswordForm onDone={() => modals.close(id)} />,
    });
  };

  return (
    <AppShell
      header={{ height: 56, collapsed: false }}
      navbar={{ width: 248, breakpoint: 'sm', collapsed: { mobile: !opened } }}
      padding={0}
      styles={{ main: { background: 'var(--mis-surface)' }, navbar: { borderColor: 'var(--mis-border)' }, header: { borderColor: 'var(--mis-border)' } }}
    >
      <AppShell.Header px="md">
        <Group h="100%" justify="space-between">
          <Group gap="sm">
            <Burger opened={opened} onClick={toggle} hiddenFrom="sm" size="sm" aria-label="Меню" />
            <Text fw={600}>МИС · учёт</Text>
          </Group>
          <Text size="sm" c="dimmed" visibleFrom="sm">
            {me?.name}
          </Text>
        </Group>
      </AppShell.Header>
      <AppShell.Navbar p="sm">
        <Stack justify="space-between" h="100%">
          <Stack gap={4}>
            {navFor(me).map((n) => (
              <NavLink
                key={n.to}
                component={Link}
                to={n.to}
                label={n.label}
                leftSection={<n.icon size={18} stroke={1.8} />}
                active={pathname.startsWith(n.to)}
                onClick={close}
                style={{ borderRadius: 12 }}
              />
            ))}
          </Stack>
          <Stack gap={6} p="xs">
            <div>
              <Text size="sm" fw={500}>
                {me?.name}
              </Text>
              <Text size="xs" c="dimmed">
                {roleText}
              </Text>
            </div>
            <UnstyledButton onClick={changePassword}>
              <Group gap={6}>
                <IconKey size={16} />
                <Text size="sm">Сменить пароль</Text>
              </Group>
            </UnstyledButton>
            <UnstyledButton onClick={() => void logout()} aria-label="Выйти">
              <Group gap={6}>
                <IconLogout size={16} />
                <Text size="sm">Выйти</Text>
              </Group>
            </UnstyledButton>
          </Stack>
        </Stack>
      </AppShell.Navbar>
      <AppShell.Main>{children}</AppShell.Main>
    </AppShell>
  );
}
